function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSave = function SvgSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14 0H2a2.006 2.006 0 0 0-2 2v14a2.006 2.006 0 0 0 2 2h14a2.006 2.006 0 0 0 2-2V4Zm2 16H2V2h11.2L16 4.8ZM9 9.5a2.5 2.5 0 1 0 2.5 2.5A2.476 2.476 0 0 0 9 9.5ZM4.262 4H12v2H4.262Z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgSave;